import React, { FC } from "react";

import { VerticalImage, VerticalSlider } from "./vertical-slider";

export interface VerticalSliderContainerProps {
  itemsLists: VerticalImage[][];
  baseVelocity?: number;
  containerClassName?: string;
}

export const VerticalSliderContainer: FC<VerticalSliderContainerProps> = ({
  itemsLists,
  baseVelocity = 100,
  containerClassName,
}) => {
  return (
    <div className={`overflow-hidden max-h-[100vh] ${containerClassName ?? ""} flex gap-1`}>
      {itemsLists.map((items, i) => (
        <VerticalSlider items={items} key={i} baseVelocity={baseVelocity * (1 - 2 * (i % 2))} />
      ))}
    </div>
  );
};
